import React, { useState, useEffect, useContext, useLayoutEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import GlobalStateContext from '../../context';
import { Icon } from 'antd';
import { protectedRoutesPrefix } from '../../routers/routes';
import logo from "../../assets/images/logo_transparent_cut_landscape.png";
import { url } from '../../utils';

const blockStyle = {
    position: 'relative',
    marginBottom: '1px solid #eee',
    // padding: '15px 0px',
};
const defaultStyle = {
    display: "none",
    padding: '0px 0px'
};

// Updated blockHeaderPages to include a regex pattern as a string
const blockHeaderPages = [
  'signup', 
  'login', 
  'reset-password', 
  'privacy', 
  'terms', 
  'pricing', 
  'verification', 
  'channel', 
  'pricing', 
  'watch',
  'instant', 
//   '/', 
  '/^[a-fA-F0-9]{24}$/',

];

export default function Header(props) {
    const location = useLocation();
    const [block, setBlockstate] = useState(false);
    const [showMenus, setMenuVisibility] = useState(true);
    const [state] = useContext(GlobalStateContext);
    const { user,header_actions } = state;

    const queryParams = new URLSearchParams(location.search);
    console.log(queryParams.get("dHeader"));

    const onBarsClick = () => {
        setMenuVisibility(!showMenus);
    };

    useEffect(() => {
        (() => {
            const clen = location.pathname.replace("/", "").split("/");

            // Convert regex-like strings to RegExp objects
            const union = clen.filter(item => {
                return blockHeaderPages.some(page => {
                    if (page.startsWith('/') && page.endsWith('/')) {
                        const regexPattern = new RegExp(page.slice(1, -1));
                        return regexPattern.test(item);
                    }
                    return page === item;
                });
            });

            console.log(union);
            setBlockstate(union.length > 0);
        })();
    }, [location.pathname]);

    useLayoutEffect(() => {
        const _listener = () => {
            const mm = window.matchMedia("(min-width: 991px)");
            if (mm.matches) {
                setMenuVisibility(true);
            } else {
                setMenuVisibility(false);
            }
        };
        window.addEventListener('resize', _listener);
        _listener();
    }, []);

    return (
        !queryParams.get("hideHeader") ?
            <div className="nav-stack">
                <header className="app2 loding-header nav-abs custom-scroll bg-white" style={block ? blockStyle : defaultStyle}>
                    {/* <div className="animated-bg"><i></i><i></i><i></i></div> */}
                    <div className="nav-container">
                        <div className="row">
                            <div className="col">
                                <nav>
                                    <Link className="home-logo-link" to={user ?"/app":"/"} style={{ marginLeft: '0.5rem' }}>
                                        {/* <span className="app-logo-text">{environments.app.name}</span> */}
                                        <img alt="" className="img-fluid logo" src={logo} />
                                    </Link>

                                    <div className="m-l-auto" id="">
                                        {/* <ul className="">
                                            <li >
                                                <Link className="btn text-primary m-1 pl-3 pr-3 pt-1 pb-1 " to={`/${protectedRoutesPrefix}`} >
                                                    Login
                                                </Link>
                                            </li>
                                        </ul> */}
                                        {!user ?
                                            <ul className="flex flex-row">
                                                <li>
                                                    <Link className="text-dark" to="/login"> Login </Link>
                                                </li>
                                                <li>
                                                    <Link className="text-dark" to="/signup"> Signup </Link>
                                                </li>
                                            </ul>
                                            :
                                            <ul className="main-menu">
                                               { header_actions &&  header_actions }
                                                {!header_actions &&<li>
                                                    <Link className="text-primary" to={ url("app")}> Dashboard</Link>
                                                </li>}
                                            </ul>
                                        }
                                    </div>
                                    {/* <div className="responsive-btn ">
                                        {showMenus ?
                                            <Icon type="up-circle" theme="twoTone" onClick={onBarsClick} />
                                            :
                                            <Icon type="down-circle" theme="twoTone" onClick={onBarsClick} />
                                        }
                                    </div> */}
                                </nav>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
            :
            <></>
    );
}
